<template>
  <div class="banner-tour">
    <div class="banner-tour__title">Оцените планировку онлайн!</div>
    <button
      type="button"
      class="btn btn-white btn-small stretched-link banner-tour__button"
      @click="
        $vfm.show({
          component: 'PopupPanorama',
          bind: {
            title: tour?.name,
            src: tour?.url,
          },
        })
      "
    >
      {{ tour?.name || "Интерьерный 3д-тур" }}
    </button>
  </div>
</template>
<script>
export default {
  inject: ["mainStore"],
  computed: {
    tour() {
      const url = this.mainStore?.state?.data?.panoramas?.list?.filter((el) => {
        return el.name === "Интерьерный 3Д-тур";
      })?.[0];
      if (!url) return "";
      return url;
    },
  },
};
</script>
<style scoped>
.banner-tour {
  background: #00543d;
  padding: 20px;
  margin-top: 40px;
}
.banner-tour__title {
  font-family: "Oranienbaum", "Times New Roman", sans-serif;
  font-weight: 400;
  font-size: 36px;
  line-height: 31.2px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #ffffff;
}
.banner-tour__button {
  margin-top: 15px;
  position: relative;
  width: 100%;
  padding: 18px 20px;
}
@media (max-width: 767px) {
  .banner-tour {
    margin-top: 0;
    margin-bottom: 25px;
  }
  .banner-tout__title {
    font-size: 24px;
  }
  .banner-tour__button {
    padding: 11px 10px;
    font-size: 17px;
  }
}
</style>
